<template>
    <div class="pa-5 pt-2 pb-2">
        <v-row no-gutters class="py-2">
            <v-col class="pt-0 pb-1">
                <v-col class="col-item row-title pa-0">{{ "Invoice ID" | t }}</v-col>
                <v-col class="col-item pa-0">
                    {{ activeExportInvoice.id ? activeExportInvoice.id : "-" }}
                </v-col>
            </v-col>
            <v-col class="pt-0 pb-1">
                <v-col class="col-item row-title pa-0">{{ "Invoice date" | t }}</v-col>
                <v-col class="col-item pa-0">
                    {{ activeExportInvoice.invoice_date ? activeExportInvoice.invoice_date : "-" }}
                </v-col>
            </v-col>
            <v-col class="pt-0 pb-1">
                <v-col class="col-item row-title pa-0">{{ "Arrival date" | t }}</v-col>
                <v-col class="col-item pa-0">
                    {{ activeExportInvoice.arrival_date ? activeExportInvoice.arrival_date : "-" }}
                </v-col>
            </v-col>
            <v-col class="pt-0 pb-1">
                <v-col class="col-item row-title pa-0">{{ "Payroll date" | t }}</v-col>
                <v-col class="col-item pa-0">
                    {{ getPayrollDate(activeExportInvoice.payroll_date) }}
                </v-col>
            </v-col>
            <v-col class="pt-0 pb-1">
                <v-col class="col-item row-title pa-0">{{ "Approved" | t }}</v-col>
                <v-col class="col-item pa-0">
                    <v-icon small v-if="activeExportInvoice.is_active" color="green">fal fa-check</v-icon>
                    <v-icon small v-else color="red">fal fa-minus</v-icon>
                    <span class="pl-2">{{ activeExportInvoice.is_active ? t("Yes") : t("No") }}</span>
                </v-col>
            </v-col>
        </v-row>
        <v-divider />
        <v-row no-gutters class="py-2">
            <v-col class="pl-0">
                <v-col class="col-item row-title pl-0">{{ "Sum" | t }}</v-col>
                <v-col class="col-item font-weight-bold pl-0">
                    {{ activeExportInvoice.total_net | rn }}
                </v-col>
            </v-col>
            <v-col>
                <v-col class="col-item row-title pl-0">{{ "Profit" | t }}</v-col>
                <v-col class="col-item font-weight-bold pl-0">
                    {{ activeExportInvoice.total_profit | rn }}
                </v-col>
            </v-col>
            <v-col>
                <v-col class="col-item row-title pl-0">{{ "Confirmed sum" | t }}</v-col>
                <v-col class="col-item pl-0">
                    {{ activeExportInvoice.total_arrived | rn }}
                </v-col>
            </v-col>
            <v-col>
                <v-col class="col-item row-title pl-0">{{ "Percent" | t }}</v-col>
                <v-col class="col-item pl-0">
                    {{ activeExportInvoice.percent ? activeExportInvoice.percent + " %" : "-" }}
                </v-col>
            </v-col>
            <v-col>
                <v-col class="col-item row-title pl-0">
                    {{ "Marginal" | t }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="info-icon"> info</v-icon>
                        </template>
                        <span>{{ "From export price" | t }}</span>
                    </v-tooltip>
                </v-col>
                <v-col class="col-item pl-0">
                    {{
                                    activeExportInvoice.total_profit && activeExportInvoice.total_net
                                        ? (Math.round((activeExportInvoice.total_profit / activeExportInvoice.total_net) * 100 * 100) / 100).toFixed(
                                              2
                                          ) + '%'
                                        : "-"
                                }}
                </v-col>
            </v-col>
        </v-row>
        <v-divider class="pb-1" />
        <v-row no-gutters class="py-2">
            <v-col class="col-item row-title" cols="3">{{ "Client" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeExportInvoice.client_name ? activeExportInvoice.client_name : "-" }}
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="col-item row-title" cols="3">{{ "Manager" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeExportInvoice.manager_name ? activeExportInvoice.manager_name : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
    name: "general-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"]),
    },
    methods: {
        getPayrollDate(value) {
            if (value)
                return (
                    this.t(moment(value, "DD.MM.YYYY").format("MMMM")) +
                    " " +
                    moment(value, "DD.MM.YYYY").format("YYYY")
                );
            else return "-";
        },
    },
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}

.info-icon {
    font-size: 18px;
}
</style>
